import { defineComponent as _defineComponent } from 'vue'
import FormatUtils from '@/utils/format_utils';



export default /*@__PURE__*/_defineComponent({
  __name: 'CurrencyValue',
  props: {
    value: { type: Number, required: true },
    fontReal: { type: Number, required: true },
    fontSize: { type: Number, required: true },
    color: { type: String, required: false }
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;

function getColor() {
  switch (props.color) {
    case 'pink': return  'var(--option-color-pink-dark, #E02867)';
    default: return 'var(--semantic-color-primary-default, #8300C7)';
  }
}


const __returned__ = { props, getColor, get FormatUtils() { return FormatUtils } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})